// Authorization
import Auth from '~views/Authorization';
import Login from '~views/Authorization/Login';
import LoginBusiness from '~views/Authorization/LoginBusiness';
import ConfirmPassword from '~views/Authorization/ConfirmPassword';
import ForgotPassword from '~views/Authorization/ForgotPassword';
import Registration from '~views/Authorization/Registration';
import ConfirmRegistration from '~views/Authorization/ConfirmRegistration';
const UniqRegistration = () => import('~views/Authorization/UniqRegistration');

const Payment = () => import('~views/Payments');
const Packages = () => import('~views/Payments/Packages');
const PackagesPublic = () => import('~views/Payments/PackagesPublic');
const PaymentInformation = () => import('~views/Payments/PaymentInformation');
const ProfilePayment = () => import('~views/Payments/ProfilePayment');

// Managers
const Managers = () => import('~views/Dashboard/Managers');
const ManagerCreate = () => import('~views/Dashboard/Managers/Create');
const ManagerEdit = () => import('~views/Dashboard/Managers/Edit');

// Profile
import Profile from '~views/Dashboard/Profile';
import Password from '~views/Dashboard/Profile/Password';
// Lazy so IgnorePlugin (mobile build) can drop the chunk without breaking
// module-load time. Admin-only screen.
const ServerSettings = () => import('~views/Dashboard/ServerSettings');
// Admin-only activity report (unique logins / meditated users). Lazy so the
// mobile IgnorePlugin can drop the chunk together with jspdf.
const ActivityReport = () => import('~views/Dashboard/ActivityReport');
import Reminders from '~views/Dashboard/Profile/Reminders';
const UserInformation = () =>
    import('~views/Dashboard/Profile/UserInformation');
const Payments = () => import('~views/Dashboard/Profile/Payments');

// Static Pages
const Privacy = () => import('~views/Dashboard/Privacy');
const Help = () => import('~views/Dashboard/Help');
const TermsAndConditions = () => import('~views/Dashboard/TermsAndConditions');

// Businesses
const Businesses = () => import('~views/Dashboard/Businesses');
const BusinessCreate = () => import('~views/Dashboard/Businesses/Create');
const BusinessEdit = () => import('~views/Dashboard/Businesses/Edit');
const BusinessGoals = () => import('~views/Dashboard/Businesses/Goals');

//Coupons
const CouponCreate = () => import('~views/Dashboard/Coupons/Create');
const Coupons = () => import('~views/Dashboard/Coupons');

// Programs
const Programs = () => import('~views/Dashboard/Programs');
const ProgramsCreate = () => import('~views/Dashboard/Programs/Create');
const ProgramsEdit = () => import('~views/Dashboard/Programs/Edit');

// Landing Pages
const LandingPagesList = () => import('~views/Dashboard/LandingPages/List');
const LandingPagesCreate = () => import('~views/Dashboard/LandingPages/Create');
const LandingPagesEdit = () => import('~views/Dashboard/LandingPages/Edit');

const Pages = () => import('~views/Dashboard/LandingPages/View');
const PagesSessionsList = () =>
    import('~views/Dashboard/LandingPages/SessionsList');
const PagesSession = () => import('~views/Dashboard/LandingPages/OpenSession');

// Users
const CreateTemplate = () => import('~views/Dashboard/Users/CreateTemplate');
const Users = () => import('~views/Dashboard/Users/List');
const UserCreate = () => import('~views/Dashboard/Users/Create');
const UserEdit = () => import('~views/Dashboard/Users/Edit');

// Goals
const Goals = () => import('~views/Dashboard/Goals');

// Sessions
const Session = () => import('~views/Dashboard/Sessions/Session');
import Sessions from '~views/Dashboard/Sessions';
import SessionsWithSubs from '~views/Dashboard/Sessions/ListWithSubs';
import ViewSessionWithSubs from '~views/Dashboard/Sessions/ListWithSubs/ViewSessionWithSubs';
import Themes from '~views/Dashboard/Sessions/Themes';

import MindfulMomentsList from '~views/Dashboard/Sessions/MindfulMomentsList';
import MindfulMomentsView from '~views/Dashboard/MindfulMinutes/View';

// Feed
const FeedPage = () => import('~views/Dashboard/Feed/Page');

const MindfulMinuteCreate = () =>
    import('~views/Dashboard/MindfulMinutes/Create');
const MindfulMinuteEdit = () => import('~views/Dashboard/MindfulMinutes/Edit');

// Congrats page
const Congrats = () => import('~/views/Congrats');
const SuccessChallenge = () => import('~/views/Congrats/SuccessChallenge');

// Timer page
const Timer = () => import('~/views/Dashboard/Timer');

// Rate page
const Rate = () => import('~/views/Rating');
const RateChallenge = () => import('~/views/Rating/RateChallenge');

// Feedback page
const Feedback = () => import('~/views/Dashboard/Feedback');

// Feedback page
import Journal from '~/views/Dashboard/Journal';

// Unsubscribe page
const Unsubscribe = () => import('~/views/Unsubscribe');
import i18n from '../i18n';

// Page Not Found
const Dashboard = () => import('~views/Dashboard');
const SessionView = () => import('~views/Dashboard/Sessions/View');

// Coming Soon Pages
const Statistics = () => import('~/views/Dashboard/Statistics/Statistics');

const routes = {
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        document.getElementById('app')?.scrollIntoView();
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/auth',
            component: Auth,
            redirect: { name: 'auth.login' },
            children: [
                {
                    path: '/login',
                    name: 'auth.login',
                    component: Login
                },
                {
                    path: '/mcdermott-login',
                    name: 'auth.loginBusiness',
                    props: route => ({
                        ...route.query,
                        ...route.params
                    }),
                    component: LoginBusiness
                },
                {
                    path: '/confirm-password',
                    name: 'auth.confirm',
                    props: true,
                    component: ConfirmPassword
                },
                {
                    path: '/forgot-password',
                    name: 'auth.forgot',
                    props: true,
                    component: ForgotPassword
                },
                {
                    path: '/registration',
                    name: 'auth.registration',
                    component: Registration
                },
                {
                    path: '/nw',
                    props: {
                        message: i18n.t('auth.registrationHospital.message'),
                        businessId: process.env.VUE_APP_HOSPITAL_BUSINESS_ID
                    },
                    name: 'auth.HospitalRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/ADR',
                    props: {
                        message: i18n.t('auth.ADR.message'),
                        businessId: process.env.VUE_APP_ADR_BUSINESS_ID
                    },
                    name: 'auth.ADRRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/RMHC',
                    props: {
                        message: i18n.t('auth.registrationRMHC.message'),
                        businessId: process.env.VUE_APP_RMHC_BUSINESS_ID
                    },
                    name: 'auth.RMHCRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/rmhcstaff',
                    props: {
                        message: i18n.t('auth.registrationRMHCStaff.message'),
                        businessId: process.env.VUE_APP_RMHCSTAFF_BUSINESS_ID
                    },
                    name: 'auth.RMHCStaffRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/activeminds',
                    props: {
                        message: i18n.t('auth.registrationActiveMinds.message'),
                        businessId: process.env.VUE_APP_ACTIVEMINDS_BUSINESS_ID
                    },
                    name: 'auth.ActiveMindsRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/rushstaff',
                    props: {
                        message: i18n.t('auth.registrationRushStaff.message'),
                        businessId: process.env.VUE_APP_RUSHSTAFF_BUSINESS_ID
                    },
                    name: 'auth.RushStaffRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/rush',
                    props: {
                        message: i18n.t('auth.registrationRush.message'),
                        businessId: process.env.VUE_APP_RUSH_BUSINESS_ID,
                        customFields: [
                            {
                                type: 'select',
                                name: 'userType',
                                label: 'Select account type',
                                options: [
                                    {
                                        text: 'Patient',
                                        value: 'Patient'
                                    },
                                    {
                                        text: 'Caregiver',
                                        value: 'Caregiver'
                                    }
                                ]
                            }
                        ]
                    },
                    name: 'auth.RushRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/holidaychill',
                    props: {
                        message: i18n.t(
                            'auth.registrationHolidayChill.message'
                        ),
                        businessId: process.env.VUE_APP_HOLIDAYCHILL_BUSINESS_ID
                    },
                    name: 'auth.HolidayChillRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/loyola',
                    props: {
                        message: i18n.t('auth.registrationLoyola.message'),
                        businessId: process.env.VUE_APP_LOYOLA_BUSINESS_ID
                    },
                    name: 'auth.LoyolaRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/thresholds',
                    props: {
                        message: i18n.t('auth.registrationThresholds.message'),
                        businessId: process.env.VUE_APP_THRESHOLDS_BUSINESS_ID
                    },
                    name: 'auth.ThresholdsRegistration',
                    component: UniqRegistration
                },
                {
                    path: '/confirm-registration',
                    props: true,
                    name: 'auth.confirmRegistration',
                    component: ConfirmRegistration
                },
                {
                    path: '/confirm-registration/:email',
                    props: true,
                    name: 'auth.confirmRegistrationEmail',
                    component: ConfirmRegistration
                }
            ]
        },
        {
            path: '/congrats',
            component: Congrats,
            redirect: { name: 'dashboard.sessions' },
            meta: {
                access: {
                    requiresLogin: true,
                    requiredPermissions: ['admin', 'champion', 'user']
                }
            },
            children: [
                {
                    path: '/success-experience',
                    name: 'congrats.experience',
                    component: SuccessChallenge,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                }
            ]
        },
        {
            path: '/rate',
            component: Rate,
            redirect: { name: 'dashboard.rate' },
            meta: {
                access: {
                    requiresLogin: true,
                    requiredPermissions: ['member', 'admin']
                }
            },
            children: [
                {
                    path: '/rate-experience',
                    name: 'rate.experience',
                    component: RateChallenge,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['member', 'admin']
                        }
                    }
                }
            ]
        },
        {
            path: '/unsubscribe/:id',
            component: Unsubscribe,
            props: true
        },
        {
            path: '/payment',
            component: Payment,
            redirect: { name: 'dashboard.paymentInformation' },
            meta: {
                access: {
                    requiresLogin: true,
                    requiredPermissions: ['member']
                }
            },
            children: [
                {
                    path: '/subscriptions',
                    name: 'dashboard.packagesPublic',
                    component: PackagesPublic
                },
                {
                    path: '/packages',
                    name: 'dashboard.packages',
                    component: Packages,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['member']
                        }
                    }
                },
                {
                    path: '/payment-information',
                    name: 'dashboard.paymentInformation',
                    props: true,
                    component: PaymentInformation,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['member']
                        }
                    }
                }
            ]
        },
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            redirect: { name: 'dashboard.themes' },
            children: [
                {
                    path: '/privacy',
                    name: 'dashboard.privacy',
                    component: Privacy
                },
                {
                    path: '/help',
                    name: 'dashboard.help',
                    component: Help
                },
                {
                    path: '/feedback',
                    name: 'dashboard.feedback',
                    component: Feedback,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/terms-and-conditions',
                    name: 'dashboard.terms',
                    component: TermsAndConditions
                },
                {
                    path: '/pages/:id',
                    name: 'dashboard.publicPages',
                    props: true,
                    component: Pages
                },
                {
                    path: '/pages/:id/sessions/:theme',
                    name: 'dashboard.pagesSessionsList',
                    props: true,
                    component: PagesSessionsList
                },
                {
                    path: '/pages/:id/sessions/:theme/session',
                    name: 'dashboard.pagesSession',
                    props: true,
                    component: PagesSession
                },
                {
                    path: '/sessions-with-subtitles',
                    name: 'dashboard.sessionsWithSubs',
                    component: SessionsWithSubs
                },
                {
                    path: '/sessions-with-ukrainian-subtitles',
                    name: 'dashboard.sessionsSpanishWithSubs',
                    component: SessionsWithSubs,
                    props: {
                        default: true,
                        variant: 'Ukrainian'
                    }
                },
                {
                    path: '/sessions-with-spanish-subtitles',
                    name: 'dashboard.sessionsSpanishWithSubs',
                    component: SessionsWithSubs,
                    props: {
                        default: true,
                        variant: 'Spanish'
                    }
                },
                {
                    path: '/sessions-with-english-subtitles',
                    name: 'dashboard.sessionsSpanishWithSubs',
                    component: SessionsWithSubs,
                    props: {
                        default: true,
                        variant: 'English'
                    }
                },
                {
                    path: '/sessions-view-with-subtitles/:id',
                    name: 'dashboard.ViewSessionWithSubs',
                    component: ViewSessionWithSubs,
                    props: {
                        default: true,
                        variant: 'Spanish'
                    }
                },
                {
                    path: '/managers',
                    name: 'dashboard.managers',
                    component: Managers,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/managers/create',
                    name: 'dashboard.managers.create',
                    component: ManagerCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/managers/edit/:id',
                    name: 'dashboard.managers.edit',
                    component: ManagerEdit,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/document/create-template',
                    name: 'dashboard.document.crete',
                    component: CreateTemplate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['champion', 'admin']
                        }
                    }
                },
                {
                    path: '/goals',
                    name: 'dashboard.goals',
                    component: Goals,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/users',
                    name: 'dashboard.users',
                    component: Users,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['champion', 'admin']
                        }
                    }
                },
                {
                    path: '/users/by-business/:id',
                    name: 'dashboard.users.by.business',
                    component: Users,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/users/create',
                    name: 'dashboard.users.create',
                    component: UserCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['champion', 'admin']
                        }
                    }
                },
                {
                    path: '/users/edit/:id',
                    name: 'dashboard.users.edit',
                    component: UserEdit,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['champion', 'admin']
                        }
                    }
                },
                {
                    path: '/businesses',
                    name: 'dashboard.businesses',
                    component: Businesses,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/businesses/create',
                    name: 'dashboard.businesses.create',
                    component: BusinessCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/businesses/:id/goals',
                    name: 'dashboard.businesses.goals',
                    component: BusinessGoals,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/businesses/edit/:id',
                    name: 'dashboard.businesses.edit',
                    component: BusinessEdit,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/reports/activity',
                    name: 'dashboard.reports.activity',
                    component: ActivityReport,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/coupons',
                    name: 'dashboard.coupons',
                    component: Coupons,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/coupons/create',
                    name: 'dashboard.coupons.create',
                    component: CouponCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/programs',
                    name: 'dashboard.programs',
                    component: Programs,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/landing-pages',
                    name: 'dashboard.pages',
                    component: LandingPagesList,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/landing-pages/create',
                    name: 'dashboard.pages.create',
                    component: LandingPagesCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/landing-pages/edit/:id',
                    name: 'dashboard.pages.edit',
                    component: LandingPagesEdit,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/programs/create',
                    name: 'dashboard.programs.create',
                    component: ProgramsCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/programs/edit/:id',
                    name: 'dashboard.programs.edit',
                    component: ProgramsEdit,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/profile',
                    name: 'dashboard.profile',
                    component: Profile,
                    redirect: { name: 'dashboard.profile.information' },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    },
                    children: [
                        {
                            path: '/profile/user-information',
                            name: 'dashboard.profile.information',
                            component: UserInformation,
                            meta: {
                                access: {
                                    requiresLogin: true,
                                    requiredPermissions: [
                                        'admin',
                                        'champion',
                                        'instructor',
                                        'member'
                                    ]
                                }
                            }
                        },
                        {
                            path: '/profile/subscription-details',
                            name: 'dashboard.profile.payments',
                            component: Payments,
                            meta: {
                                access: {
                                    requiresLogin: true,
                                    requiredPermissions: ['member']
                                }
                            }
                        },
                        {
                            path: '/profile/reminders',
                            name: 'dashboard.profile.reminders',
                            component: Reminders,
                            meta: {
                                access: {
                                    requiresLogin: true,
                                    requiredPermissions: ['member']
                                }
                            }
                        },
                        {
                            path: '/profile/password',
                            name: 'dashboard.profile.password',
                            component: Password,
                            meta: {
                                access: {
                                    requiresLogin: true,
                                    requiredPermissions: [
                                        'admin',
                                        'champion',
                                        'instructor',
                                        'member'
                                    ]
                                }
                            }
                        },
                        {
                            path: '/admin/settings',
                            name: 'dashboard.server.settings',
                            component: ServerSettings,
                            meta: {
                                access: {
                                    requiresLogin: true,
                                    requiredPermissions: ['admin']
                                }
                            }
                        }
                    ]
                },
                {
                    path: '/update-card',
                    name: 'dashboard.updateCard',
                    component: ProfilePayment,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin', 'member']
                        }
                    }
                },
                {
                    path: '/timer',
                    name: 'dashboard.timer',
                    component: Timer,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin', 'member', 'champion']
                        }
                    }
                },
                {
                    path: '/sessions',
                    props: route => ({
                        duration: parseInt(route.query.duration),
                        title: route.query.title,
                        theme: route.query.theme,
                        ...route.params
                    }),
                    name: 'dashboard.sessions',
                    component: Sessions,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                },
                {
                    path: '/journal',
                    name: 'dashboard.journal',
                    component: Journal,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin', 'member']
                        }
                    }
                },
                {
                    path: '/mindful-moments',
                    name: 'dashboard.mindfulMinutes',
                    component: MindfulMomentsList,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                },
                {
                    path: '/mindful-moments/view/:id',
                    name: 'dashboard.mindfulMinutesItem',
                    props: true,
                    component: MindfulMomentsView,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                },
                {
                    path: '/themes',
                    name: 'dashboard.themes',
                    component: Themes,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                },
                {
                    path: '/sessions/create',
                    name: 'dashboard.sessions.create',
                    component: Session,
                    props: {
                        title: i18n.t('sessions.create.titleLive')
                    },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/sessions/create-live-recorded',
                    name: 'dashboard.sessions.createRecordedLive',
                    component: Session,
                    props: {
                        title: i18n.t('sessions.create.titleLive'),
                        isLiveRecorded: true
                    },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/feed',
                    name: 'dashboard.feed',
                    component: FeedPage,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                },
                {
                    path: '/sessions/create-recorded',
                    name: 'dashboard.sessions.createRecorded',
                    component: Session,
                    props: {
                        title: i18n.t('sessions.create.titleRecorded'),
                        isRecorded: true
                    },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/create-mindful-minute',
                    name: 'dashboard.createMindfulMinutes',
                    component: MindfulMinuteCreate,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/edit-mindful-minute/:id',
                    name: 'dashboard.editMindfulMinutes',
                    component: MindfulMinuteEdit,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/sessions/edit/:id',
                    name: 'dashboard.sessions.edit',
                    component: Session,
                    props: {
                        default: true,
                        title: i18n.t('sessions.edit.title'),
                        isEditing: true
                    },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/sessions/edit-recorded-live/:id',
                    name: 'dashboard.sessions.editRecordedLive',
                    component: Session,
                    props: {
                        default: true,
                        title: i18n.t('sessions.edit.title'),
                        isEditing: true,
                        isLiveRecorded: true
                    },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/sessions/edit-recorded/:id',
                    name: 'dashboard.sessions.editRecorded',
                    component: Session,
                    props: {
                        title: i18n.t('sessions.edit.title'),
                        isEditing: true,
                        isRecorded: true
                    },
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/sessions/edit-mindful-minute/:id',
                    name: 'dashboard.sessions.editMindfulMinute',
                    component: Session,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin']
                        }
                    }
                },
                {
                    path: '/sessions/view/:id',
                    name: 'dashboard.sessions.view',
                    component: SessionView,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: [
                                'admin',
                                'champion',
                                'instructor',
                                'member'
                            ]
                        }
                    }
                },
                {
                    path: '/statistics',
                    name: 'dashboard.statistics',
                    component: Statistics,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin', 'champion', 'member']
                        }
                    }
                },
                {
                    path: '/statistics/by-user/:id',
                    name: 'dashboard.statistics.by.user',
                    component: Statistics,
                    props: true,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['admin', 'champion']
                        }
                    }
                },
                {
                    path: '/my-practice',
                    name: 'dashboard.statistics.user',
                    component: Statistics,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['member']
                        }
                    }
                }
            ]
        }
    ]
};

// --------------------------------------------------------------------------
// Mobile build: strip every route the `member` role cannot reach.
//
// The Capacitor app is member-only — admins, champions and instructors use
// the web build to manage businesses, users, programs, sessions, etc. We
// never want those screens reachable on mobile (and ideally we never want
// their JS chunks to be installed in the APK either).
//
// Filter rules:
//   • If a route has `meta.access.requiredPermissions` and 'member' is NOT
//     in it → drop the route. (Admin / champion / instructor only.)
//   • If a route has `meta.access.requiredPermissions` containing 'member'
//     → keep. (Shared with admin or member-only.)
//   • If a route has no `requiredPermissions` (public auth, congrats, rate,
//     unsubscribe, static pages) → keep.
//   • Recursively apply to children. If a parent ends up with no children
//     → drop the parent too (no orphan layouts).
//
// The actual JS chunks for admin views are removed from the build by
// webpack's IgnorePlugin entries in vue.config.js — see the `chainWebpack`
// block there. This filter handles the routing layer.
// --------------------------------------------------------------------------
function isMemberAccessible(route) {
    const perms = route?.meta?.access?.requiredPermissions;
    if (!perms || perms.length === 0) return true;
    return perms.includes('member');
}

function filterMemberRoutes(routeArray) {
    if (!Array.isArray(routeArray)) return routeArray;
    return routeArray
        .map(route => {
            if (route.children && route.children.length) {
                const children = filterMemberRoutes(route.children);
                // Drop a parent layout if every child became inaccessible.
                if (children.length === 0 && !isMemberAccessible(route)) {
                    return null;
                }
                return { ...route, children };
            }
            return isMemberAccessible(route) ? route : null;
        })
        .filter(Boolean);
}

if (process.env.VUE_APP_MOBILE_BUILD === '1') {
    routes.routes = filterMemberRoutes(routes.routes);
}

export default routes;
